import { useContext, Fragment } from "react";
import { Context } from "Context";
import useCheckMediaQuery from "hooks/useCheckMediaQuery";
import Link from "components/shared/Link";
import Title from "components/shared/Title";
import Separator from "components/shared/Separator";
import Accordion from "components/shared/Accordion";
import QuestionList from "components/questions/QuestionList";
import { HEADING_TYPES } from "components/shared/Heading";

const RelatedQuestionWall = ({ relatedQuestions }) => {
	const { config } = useContext(Context);
	const mainClass = "help-related-question-wall";
	const isMobileView = useCheckMediaQuery(config.mobileMediaQuery);

	if (isMobileView) {
		return (
			<div className={mainClass}>
				{relatedQuestions?.name && (
					<Accordion title={relatedQuestions.name} modifier="relatedQuestions">
						{relatedQuestions.questions && (
							<QuestionList questions={relatedQuestions.questions} />
						)}
						{relatedQuestions?.webLinks && (
							<Fragment>
								<Separator />
								<Link
									{...relatedQuestions.webLinks[0]}
									className={`${mainClass}__moreLink`}
								/>
							</Fragment>
						)}
					</Accordion>
				)}
			</div>
		);
	}

	return (
		<div className={mainClass}>
			<Separator />
			{relatedQuestions.name && (
				<Title
					headingType={HEADING_TYPES.h4}
					title={relatedQuestions.name}
					modifier="relatedQuestions"
				/>
			)}
			<Separator />
			{relatedQuestions.questions && (
				<div>
					<QuestionList questions={relatedQuestions.questions} />
				</div>
			)}
			{relatedQuestions?.webLinks && (
				<Link
					{...relatedQuestions.webLinks[0]}
					className={`${mainClass}__moreLink`}
				/>
			)}
		</div>
	);
};

export default RelatedQuestionWall;
